import { render, staticRenderFns } from "./ContractFilterChips.vue?vue&type=template&id=63295677&"
import script from "./ContractFilterChips.vue?vue&type=script&lang=js&"
export * from "./ContractFilterChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports